<template>
  <div class="main-component-wrapper">
    <div v-if="showElseBlock" class="elif-block-wrapper">
      <div class="elif-block">
        <span>{{ $t('else') }}</span>
      </div>

      <div class="left-spacer elif">
        <div class="connection-line-if-block" />
      </div>
    </div>

    <div class="component-wrapper" :class="selected && 'selected'" @click="onClick" v-if="data?.type !== 'ifCondition'">
      <div class="delete-wrapper" @click="onDelete">
        <img src="@/assets/images/trash.svg" />
      </div>

      <div class="icon-wrapper" :class="flowComponent.color">
        <img :src="getUserFlowIcon(data.type)" />
      </div>

      <div class="info-wrapper">
        <span class="title">{{ flowComponent.name }}</span>
        <span class="description">{{ flowComponent.description }}</span>
      </div>
    </div>

    <div v-if="data?.type !== 'ifCondition'" class="connection-line" />

    <div v-if="data?.type === 'ifCondition'" class="branch-line" :style="{width: `${93}px`}"/>

    <div v-if="data?.type === 'ifCondition'" class="if-block-wrapper">
      <div class="left-spacer">
        <div class="connection-line-if-block" />
      </div>

      <div class="if-block">
        <span>{{ $t('if') }}</span>
      </div>
    </div>

    <div v-if="data?.type === 'ifCondition'" class="if-block-wrapper">
      <div class="left-spacer">
        <div class="connection-line-if-block" />
      </div>

      <div class="left-spacer if-bottom-line">
        <div class="connection-line-if-block" />
      </div>
    </div>

  </div>
</template>


<script>
import PlayIcon from "@/assets/images/play.svg";
import BranchIcon from "@/assets/images/branchWhite.svg";
import LightningIcon from "@/assets/images/lightningBlue.svg";
import FilterIcon from "@/assets/images/filterYellow.svg";
import { getUserFlowIcon } from "@/components/user-flow/icons";


export default {
  name: 'FlowComponent',
  methods: { getUserFlowIcon },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    selected: {
      type: Boolean,
      default: false,
    },
    indentationLevel: {
      type: Number,
      default: 1,
    },
    showElseBlock: {
      type: Boolean,
      default: false,
    },
    onClick: {
      type: Function,
      default: () => {},
    },
    onDelete: {
      type: Function,
      default: () => {},
    },
    findWhenComponentByType: {
      type: Function,
      default: () => {
        return null;
      },
    },
    findThenComponentByType: {
      type: Function,
      default: () => {
        return null;
      },
    },
    findIfComponentByType: {
      type: Function,
      default: () => {
        return null;
      },
    },
  },
  data() {
    return {
    }
  },
  computed: {
    flowComponent() {
      if (this.data.type === 'whenStart') {
        return {
          icon: PlayIcon,
          color: 'green',
          name: this.$t('flow_when_add_trigger'),
          description: this.$t('flow_when_add_trigger_desc'),
        }
      } else if (this.data.type === 'thenStart') {
        return {
          icon: LightningIcon,
          color: 'blue',
          name: this.$t('flow_then_add_action'),
          description: this.$t('flow_then_add_action_desc'),
        }
      } else if (this.data.type === 'ifStart') {
        return {
          icon: FilterIcon,
          color: 'yellow',
          name: this.$t('flow_if_add_condition'),
          description: this.$t('flow_if_add_condition_desc'),
        }
      } else if (this.data.type === 'default') {
        return {
          icon: BranchIcon,
          color: 'gray',
          name: this.$t('flow_new_component'),
          description: this.$t('flow_new_component_desc'),
        }
      } else {
        const tempWhen = this.findWhenComponentByType(this.data.type);
        const tempThen = this.findThenComponentByType(this.data.type);
        const ifThen = this.findIfComponentByType(this.data.type);

        if (tempWhen) {
          return {
            name: tempWhen.name,
            color: 'green',
            description: tempWhen.description,
            icon: tempWhen.icon,
          }
        } else if (tempThen) {
          return {
            name: tempThen.name,
            color: 'blue',
            description: tempThen.description,
            icon: tempThen.icon,
          }
        } else if (ifThen) {
          return {
            name: ifThen.name,
            color: 'yellow',
            description: ifThen.description,
            icon: ifThen.icon,
          }
        }

        return {
          icon: BranchIcon,
          color: 'gray',
          name: this.$t('flow_unknown_component'),
          description: this.$t('flow_unknown_component_desc'),
        }
      }
    }
  }
}
</script>

<style scoped>
.main-component-wrapper {
  display: flex;
  flex-direction: column;
}

.component-wrapper {
  position: relative;
  border: 2px solid #EAECF0;
  background-color: #fff;
  border-radius: 16px;
  padding: 15px;
  width: 400px;
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
  cursor: pointer;
  transition: border 0.2s, background-color 0.2s;
}

.component-wrapper.selected {
  border: 2px solid #1C3CD5;
  background-color: #F5F7FF;
}

.component-wrapper:hover .delete-wrapper {
  opacity: 1;
}

.delete-wrapper {
  display: flex;
  opacity: 0;
  position: absolute;
  width: 36px;
  height: 36px;
  top: -18px;
  right: 15px;
  background-color: #fff;
  border-radius: 9px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: 1px solid #EAECF0;
  transition: opacity 0.2s, background-color 0.2s;
}

.delete-wrapper:hover {
  background-color: #F5F7FF;
}

.delete-wrapper img {
  width: 16px;
  height: 16px;
}

.icon-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  border-radius: 16px;
}

.icon-wrapper.green {
  background-color: #e3fcef;
}

.icon-wrapper.gray {
  background-color: #EAECF0;
}

.icon-wrapper.yellow {
  background-color: #FFF0B3;
}

.icon-wrapper.blue {
  background-color: #DEEBFF;
}

.icon-wrapper img {
  width: 26px;
  height: 26px;
}

.info-wrapper {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.info-wrapper .title {
  font-family: 'euclid_medium', sans-serif;
  font-size: 14px;
  color: #040C2D;
}

.info-wrapper .description {
  font-family: 'euclid_regular', sans-serif;
  font-size: 12px;
  color: #98A2B3;
}

.connection-line {
  width: 2px;
  background-color: #EAECF0;
  margin-left: 39px;
  min-height: 40px;
}

.connection-line-if-block {
  width: 2px;
  background-color: #EAECF0;
  min-height: 26px;
}

.branch-line {
  content: "";
  display: block;
  min-height: 24px;
  border-top: 2px solid #EAECF0;
  border-right: 2px solid #EAECF0;
  border-radius: 0 16px 0 0;
  border-bottom: none;
  border-left: 2px solid #EAECF0;
  margin-left: 39px;
}

.if-block {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  background-color: #EAECF0;
  width: 26px;
  height: 26px;
  margin-left: 37px;
}

.elif-block {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  background-color: #EAECF0;
  width: 56px;
  height: 26px;
  margin-left: 12px;
}

.if-bottom-line {
  margin-left: 10px;
}

.elif-block span, .if-block span {
  font-family: 'euclid_semi_bold', sans-serif;
  font-size: 10px;
  color: #040C2D;
}

.if-block-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.elif-block-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.left-spacer {
  width: 80px;
  height: inherit;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
